import { html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import {
  THEME_DEFAULT,
  THEMES,
  SIZE_DEFAULT,
  SIZES
} from './_lib/constants.js';
import { themes as listThemes } from './_lib/themes.js';
import { getI18n } from './_i18n/i18n';
import styleComponent from './_style/progress-multi.style.js';
import { resolveLocale } from '@outbook/resolve-locale';

class ComponentProgressMulti extends LitElement {
  static styles = styleComponent;

  static properties = {
    text: { type: String },
    size: { type: String },
    live: { type: String },
    theme: { type: String },
    locale: { type: String }
  };

  constructor() {
    super();
    this.size = SIZE_DEFAULT;
    this.live = null;
    this.text = null;
    this.theme = THEME_DEFAULT;
  }

  get resolvedLocale() {
    return resolveLocale(this);
  }

  render() {
    const literals = getI18n(this.resolvedLocale);
    const theme = THEMES.includes(this.theme) ? this.theme : THEME_DEFAULT;
    const size = SIZES.includes(this.size) ? this.size : SIZE_DEFAULT;
    const displayText = this.text || literals.loading;
    const isAlert = this.live === 'alert';

    const mainClasses = classMap({
      progress: true,
      [`progress--size-${size}`]: true,
      [`progress--type-${theme}`]: true
    });

    return html`
      <div
        class="${mainClasses}"
        role="${isAlert ? 'alert' : 'status'}"
        aria-live="${isAlert ? 'assertive' : 'polite'}"
        aria-label="${displayText}"
      >
        ${listThemes[theme]({ text: displayText })}
      </div>
    `;
  }
}

if (!customElements.get('outbook-progress-multi')) {
  customElements.define('outbook-progress-multi', ComponentProgressMulti);
}

export function ProgressMulti(props) {
  const { size, ariaLive, text, theme, locale } = props;

  return html`
    <outbook-progress-multi
      text="${ifDefined(text)}"
      size="${ifDefined(size)}"
      live="${ifDefined(ariaLive)}"
      theme="${ifDefined(theme)}"
      locale="${ifDefined(locale)}"
    ></outbook-progress-multi>
  `;
}
